import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useSWR from 'swr';
import { dataFetcher, endpoints, baseUrl, cloudBaseUrl } from 'Api';
import axios from 'axios';
import { Skeleton } from '@mui/material';
import { AppContext, AuthContext } from 'Context';
import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from 'Components';
import CustomButton from 'Components/button/CustomButton';
import { get } from 'lodash';
import {
  awsConfig,
  generateS3Url,
  getBucketName,
  getBucketNamePath,
} from '../../../../Api/awsConfig';
import Logo from '../../../../Assets/published.png';
import { StoragePage } from '../components/page';
import { videoArray } from './DataArray';
import { photoArray } from './PhotoArray';
import Publish from '../PublishUi/Publish';
import Sort from '../../../../Assets/sort.png';
import Shimmer from '../Shimmer';
import styles from './index.module.css';

export const Storage = () => {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const location = useLocation();
  const [data, setData] = useState({ results: [], next: null });
  const [loading, setLoading] = useState(false);
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [page, setPage] = useState(1);
  const containerRef = useRef(null);
  const {
    storageSearchTerm,
    storageSelectedDate,
    storageTabTitle,
    storageSelectedItems,
    setStorageSelectedItems,
    setOpenX,
    cloudToken,
    setAppSnackbar,
    userDetails,
  } = useContext(AppContext);
  const { getToken } = useContext(AuthContext);
  const userId = userDetails?.isSubscription?.user_id;
  const [thumbnailSelected, setThumbnailSelected] = useState();
  const [sendDataLoader, setSendDataLoader] = useState(false);
  const [addToProjector, setAddToProjector] = useState(false);
  const [order, setOrder] = useState('ascending');
  const [detailsData, setDetailsData] = useState({
    title: '',
    duration: undefined,
    height: undefined,
    width: undefined,
    description: '',
    categrory: undefined,
    visibility: 2,
    group: [], // ✅ Must be an array!
  });
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / 1024 ** i).toFixed(2)} ${sizes[i]}`;
  };
  const groupByDate = (files) => {
    if (!Array.isArray(files)) return {};
    return files.reduce((acc, file) => {
      const dateObj = new Date(file.uploaded_at);
      const formattedDate = dateObj.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(file);
      return acc;
    }, {});
  };
  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const groupedFiles = groupByDate(data?.results);
  const handleSelect = (item) => {
    const isAlreadySelected = storageSelectedItems.some(
      (selected) => selected.id === item.id
    ); // assuming `id` is unique
    if (isAlreadySelected) {
      setStorageSelectedItems(
        storageSelectedItems.filter((selected) => selected.id !== item.id)
      );
    } else {
      setStorageSelectedItems([...storageSelectedItems, item]);
    }
  };
  const fetchData = async (pageNumber = 1) => {
    if (pageNumber === 1) setLoading(true);
    setLoadingNextPage(pageNumber > 1);
    const token = cloudToken?.access;
    const isLocalhost = window.location.hostname !== 'localhost';
    try {
      const baseUrl = `${cloudBaseUrl}/documents/list/?type=video&order=${order}&limit=50&search=${storageSearchTerm}&date=${storageSelectedDate}`;
      const params = new URLSearchParams({
        type: storageTabTitle === 0 ? 'video' : 'photo',
        order: 'descending',
        page: String(pageNumber),
      });
      if (storageSearchTerm) {
        params.append('search', storageSearchTerm);
      }
      if (storageSelectedDate) {
        params.append('date', storageSelectedDate);
      }
      // const url = `${baseUrl}?${params.toString()}`;
      const url = baseUrl;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      // Parse the response body
      const responseData = await response.json();
      console.log('Response Data:', responseData);
      // setData((prev) => ({
      //   ...responseData,
      //   results: [...(prev?.results ?? []), ...(responseData?.results ?? [])],
      // }));
      setData((prev) => ({
  ...responseData,
  results:
    pageNumber === 1
      ? responseData?.results ?? []
      : [...(prev?.results ?? []), ...(responseData?.results ?? [])],
}));

      setPage(pageNumber);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingNextPage(false);
    }
  };
  useEffect(() => {
    if (cloudToken?.access) {
      fetchData(1);
    }
  }, [
    storageSearchTerm,
    storageSelectedDate,
    storageTabTitle,
    cloudToken,
    order,
  ]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (
        !loading
        && data.next
        && !loadingNextPage
        && scrollTop + clientHeight + 100 >= scrollHeight
      ) {
        const nextPage = page + 1;
        fetchData(nextPage);
      }
    };
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [loading, data.next, page, loadingNextPage]);
  async function urlToFile(url, filename) {
    const response = await fetch(url);
    const blob = await response.blob();
    const fileType = blob.type || 'image/jpeg'; // fallback
    return new File([blob], filename, { type: fileType });
  }
  async function appendThumbnails(formData, storageSelectedItems) {
    const preThumbnails = storageSelectedItems?.[0]?.pre_thumbnails;
    if (!Array.isArray(preThumbnails) || preThumbnails.length === 0) {
      console.warn('No thumbnails found.');
      return;
    }
    // eslint-disable-next-line
    for (let index = 0; index < preThumbnails.length; index++) {
      const url = preThumbnails[index];
      try {
        // eslint-disable-next-line
        const file = await urlToFile(url, `thumbnail_${index}.jpg`);
        console.log('thumbnails[]', file);
        formData.append('thumbnails[]', file);
      } catch (err) {
        console.error(`Error processing thumbnail ${index}:`, err);
      }
    }
  }

  const convertAllUrlsToFiles = async (urls) => {
    const files = await Promise.all(
      urls.map((url, index) => urlToFile(url, `thumbnail_${index}.png`))
    );

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('thumbnails[]', file);
    });

    return formData;
  };
  useEffect(() => {
    // Clear selected items when route changes
    setStorageSelectedItems([]);
  }, [location.pathname]); // triggered every time the path changes

  const addVideo = async () => {
    const selected = storageSelectedItems[0];
    let thumbnailsArray = [];
    try {
      thumbnailsArray = JSON.parse(selected?.thumbnails || '[]');
    } catch (err) {
      console.error('Invalid thumbnails JSON:', err);
    }
    const cleanUrl = selected?.pre_thumbnail?.split('?')[0] ?? '';
    const matchedThumb = thumbnailsArray.find((thumb) => cleanUrl.includes(thumb));
    const url = `${baseUrl}/cloud/addVideo`;
    const payload = {
      title: detailsData?.title,
      description: detailsData?.description,
      file_key: storageSelectedItems[0]?.url,
      thumbnail_key: matchedThumb,
      thumbnails_keys: JSON.parse(storageSelectedItems[0]?.thumbnails || '[]'),
      category: detailsData?.categrory,
      visibility: detailsData?.visibility,
      group: detailsData?.group,
      video_size: storageSelectedItems[0]?.size,
      video_duration: 50,
      token: getToken(),
    };

    try {
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Upload Success:', response.data);
      setStorageSelectedItems([]);
      fetchData(1);
      setAddToProjector(false);
      setSendDataLoader(false);
      return response.data;
    } catch (error) {
      console.error('Upload Failed:', error?.response?.data || error.message);
      return null;
    }
  };
  const [deleteLoading, setDeleteLoading] = useState(false);
  const deleteFiles = async () => {
    setDeleteLoading(true);
  const payload = {
  ids: storageSelectedItems?.map((item) => item?.id), // e.g. [1473, 1466, 1460]
  stream_ids: [],
  streamToken: getToken(),
    };
    console.log('Payload before request:', payload);
  try {
    const response = await axios.post(
      `${cloudBaseUrl}/documents/delete-files/`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cloudToken?.access}`,
        }
      }
    );
      setStorageSelectedItems([]);
    setDeleteLoading(false);
    setTimeout(() => {
      fetchData(1);
    }, 1000);
    console.log('Delete Success:', response.data);
  } catch (error) {
 setDeleteLoading(false);
    console.error('Delete Failed:', error.response?.data || error.message);
  }
};

  const beforeDataSendToServer = (videoUrl) => {
    setSendDataLoader(true);
    addVideo();
  };

  const publishHandler = () => {
    if (addToProjector) {
      beforeDataSendToServer(storageSelectedItems[0].pre_url);
      return;
    }
    if (storageSelectedItems?.length === 1) {
      setAddToProjector(true);
    } else {
      setOpenX(true);
    }
  };

  return (
//     <StoragePage
//   title={data?.results?.length > 0 ? `${data.results.length} Videos` : 'Add videos'}
// >
//       <div className={styles.viewersDiv}>
//         <div className={styles.aboveGrid}>
//           {data?.results?.length > 0 && (
//           <button
//             onClick={() => setOrder((prev) => (prev === 'ascending' ? 'descending' : 'ascending'))}
//             className={styles.orderSort}
//           >
//             <img src={Sort} className="w-[14px]" alt="" />
//             {order === 'ascending' ? 'Latest' : 'Oldest'}
//           </button>
//           )}
//           {Object.entries(groupedFiles)?.map(([date, files]) => (
//             <div className={styles.topix}>
//               <span className={styles.date}>{date}</span>
//               <div className={styles.allViewersContainer} ref={containerRef}>
//                 {loading ? (
//                   <div className={styles.shimmer}>
//                     <Shimmer type="video" />
//                   </div>
//                 ) : data?.results?.length > 0 ? (
//                   data?.results?.map((item, index) => (
//                     <div
//                       className={styles.gridImg}
//                       key={item?.id}
//                       role="button"
//                       tabIndex={0}
//                       onClick={() => handleSelect(item)}
//                       onKeyDown={(e) => {
//                         if (e.key === 'Enter' || e.key === ' ') {
//                           handleSelect(item);
//                         }
//                       }}
//                     >
//                       <Checkbox
//                         checked={storageSelectedItems?.some(
//                           (selected) => selected.id === item.id
//                         )}
//                         icon={<></>} // ✅ safely renders nothing
//                         checkedIcon={<CheckCircleIcon />} // ✅ shown only when selected
//                         sx={{
//                           color: '#e6dfda',
//                           '&.Mui-checked': {
//                             color: '#e6dfda',
//                           },
//                         }}
//                         style={{
//                           position: 'absolute',
//                           top: '40%',
//                           left: '42%',
//                           zIndex: 2,
//                           borderRadius: 4,
//                           padding: 0,
//                           pointerEvents: 'none', // allow click-through
//                         }}
//                       />

//                       <img
//                         src={item?.pre_thumbnail}
//                         className={styles.eachbyimg}
//                         alt={item?.name}
//                       />
//                       {item?.draft_id !== null && (
//                         <img
//                           className={styles.isStream}
//                           src={Logo}
//                           alt={item?.name}
//                         />
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <div className={styles.noData}>No data found</div>
//                 )}
//                 {loadingNextPage
//                   && Array.from({ length: 16 }).map((_, index) => (
//                     <div
//                       className={styles.gridItemX}
//                       key={index + data.results.length}
//                     >
//                       <Skeleton
//                         variant="rectangular"
//                         height={130}
//                         width={100}
//                         animation="wave"
//                         sx={{
//                           borderRadius: '12px',
//                         }}
//                       />
//                     </div>
//                   ))}
//               </div>
//             </div>
//           ))}
//         </div>
//         {storageSelectedItems?.length > 0 && (
//           <div className={styles.pendingViewersContainer}>
//             <Publish
//               type="video"
//               addToProjector={addToProjector}
//               setSelectedCheckedItems={setStorageSelectedItems}
//               selectedCheckedItems={storageSelectedItems}
//               formatFileSize={formatFileSize}
//               handleDetailsChange={handleDetailsChange}
//               detailsData={detailsData}
//               setDetailsData={setDetailsData}
//               thumbnailSelected={thumbnailSelected}
//               setThumbnailSelected={setThumbnailSelected}
//             />

//             <div className={styles.buttonsfleximo}>
//               <CustomButton onClick={deleteFiles} loading={deleteLoading} border="red" name="Delete" />
//               {storageSelectedItems?.length > 0
//                 && !storageSelectedItems.some(
//                   (item) => item?.draft_id !== null
//                 ) && (
//                   <CustomButton
//                     disabled={
//                       storageSelectedItems?.length < 1 || sendDataLoader
//                     }
//                     onClick={publishHandler}
//                     loading={sendDataLoader}
//                     border="#5AA5EF"
//                     name="Publish Video"
//                   />
//                 )}
//             </div>
//           </div>
//         )}
//       </div>
// </StoragePage>
    <StoragePage>
<div className={styles.iframeContainer}>
  <iframe
    src="https://projector-cloud-web.s3.us-west-2.amazonaws.com/download_stream.html"
    title="Projector Uploader Download"
    className={styles.iframe}
    sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
  />
</div>

    </StoragePage>
  );
};
